import { fetchUpcomingInterviews } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IPlannedInterviewsByFullDate } from 'src/api/base/Interviews/types';

export type IUpcomingInterviewsState = IListState<IPlannedInterviewsByFullDate>;

const initialState: IUpcomingInterviewsState = { ...initialListState };

const upcomingInterviewsSlice = getListSlice({
  moduleName: 'upcomingInterviews',
  fetchDataThunk: fetchUpcomingInterviews,
  initialState,
});

export const upcomingInterviewsReducer = upcomingInterviewsSlice.reducer;
